import { Query, UserAttributes } from "@/types";

/**
 * Taken without any modification from Builder SDK here: https://github.com/BuilderIO/builder/blob/94f800308672b7da5422705eb83aa9629f5c6098/packages/sdks/src/blocks/personalization-container/helpers/inlined-fns.ts#L103
 */
export const filterWithCustomTargeting = (
  userAttributes: UserAttributes,
  query: Query[],
  startDate?: string,
  endDate?: string,
) => {
  function isString(val: unknown): val is string {
    return typeof val === "string";
  }

  function isNumber(val: unknown): val is number {
    return typeof val === "number";
  }

  function objectMatchesQuery(userattr: UserAttributes, query: Query): boolean {
    const result = (() => {
      const property = query.property;
      const operator = query.operator;
      let testValue = query.value;

      if (
        query &&
        query.property === "urlPath" &&
        query.value &&
        typeof query.value === "string" &&
        query.value !== "/" &&
        query.value.endsWith("/")
      ) {
        testValue = query.value.slice(0, -1);
      }

      if (!(property && operator)) {
        return true;
      }

      if (Array.isArray(testValue)) {
        if (operator === "isNot") {
          return testValue.every((val) =>
            objectMatchesQuery(userattr, { property, operator, value: val }),
          );
        }
        return !!testValue.find((val) =>
          objectMatchesQuery(userattr, { property, operator, value: val }),
        );
      }
      const value = userattr[property];

      if (Array.isArray(value)) {
        return value.includes(testValue);
      }

      switch (operator) {
        case "is":
          return value === testValue;
        case "isNot":
          return value !== testValue;
        case "contains":
          return (
            (isString(value) || Array.isArray(value)) &&
            value.includes(String(testValue))
          );
        case "startsWith":
          return isString(value) && value.startsWith(String(testValue));
        case "endsWith":
          return isString(value) && value.endsWith(String(testValue));
        case "greaterThan":
          return isNumber(value) && isNumber(testValue) && value > testValue;
        case "lessThan":
          return isNumber(value) && isNumber(testValue) && value < testValue;
        case "greaterThanOrEqualTo":
          return isNumber(value) && isNumber(testValue) && value >= testValue;
        case "lessThanOrEqualTo":
          return isNumber(value) && isNumber(testValue) && value <= testValue;
        default:
          return false;
      }
    })();

    return result;
  }
  const item = {
    query,
    startDate,
    endDate,
  };

  const now =
    (userAttributes.date && new Date(userAttributes.date)) || new Date();

  if (item.startDate && new Date(item.startDate) > now) {
    return false;
  } else if (item.endDate && new Date(item.endDate) < now) {
    return false;
  }

  if (!item.query || !item.query.length) {
    return true;
  }
  return item.query.every((filter: Query) => {
    return objectMatchesQuery(userAttributes, filter);
  });
};
